import api from "../api";
import { isNative, getPlatform } from "./platform";

// Inizializza Push nativo (FCM/APNs) + gestione tap → deep link, e i deep/universal link.
// No-op sul web. `navigate` = funzione di react-router.
export async function initPushAndDeepLinks(navigate) {
  if (!isNative()) return;

  // 1) Universal / App Links: apre la schermata interna corretta
  try {
    const { App } = await import("@capacitor/app");
    App.addListener("appUrlOpen", ({ url }) => {
      try { const u = new URL(url); navigate(u.pathname + (u.search || "")); } catch (e) {}
    });
  } catch (e) {}

  // 2) Push notifications
  try {
    const { PushNotifications } = await import("@capacitor/push-notifications");
    let perm = await PushNotifications.checkPermissions();
    if (perm.receive === "prompt") perm = await PushNotifications.requestPermissions();
    if (perm.receive !== "granted") return;

    await PushNotifications.addListener("registration", (t) => registerToken(t.value));
    await PushNotifications.addListener("registrationError", () => {});
    await PushNotifications.addListener("pushNotificationActionPerformed", (event) => {
      const dl = event?.notification?.data?.deepLink;
      if (dl) navigate(dl);
    });
    await PushNotifications.register();
  } catch (e) {}
}

async function registerToken(token) {
  if (!token) return;
  try {
    await api.put("/push/device", { platform: getPlatform(), token });
  } catch (e) { /* utente non loggato o offline: verrà ritentato al prossimo avvio */ }
}

// Rimuove il token del device (da chiamare al logout, best-effort).
export async function unregisterPushDevice() {
  if (!isNative()) return;
  try {
    const { PushNotifications } = await import("@capacitor/push-notifications");
    // nessun getter del token: la rimozione lato server avviene per token noto se disponibile
    await PushNotifications.removeAllListeners();
  } catch (e) {}
}
